import { FC } from 'react';

import classNames from 'classnames';
import { useFeaturedFlag } from '@/hooks';

import styles from './price.module.scss';

interface ISalePrice {
  price: string;
  salePrice: string;
  special?: boolean;
  className?: string;
}

const Price: FC<ISalePrice> = ({ price, salePrice, special, className }) => {
  const { isTaxAppliedMessage, showStriketroughPrice } = useFeaturedFlag();

  const ariaLabel =
    special && showStriketroughPrice
      ? `Product price: ${salePrice}, previous price: ${price}${
          isTaxAppliedMessage ? ', tax included' : ''
        }`
      : `Product price: ${salePrice}${
          isTaxAppliedMessage ? ', tax included' : ''
        }`;

  return (
    <p
      aria-label={ariaLabel}
      className={classNames(styles.price, className)}
      role="img"
    >
      {special && showStriketroughPrice && (
        <del aria-hidden="true">{price}</del>
      )}
      <ins aria-hidden="true">{salePrice}</ins>
      {isTaxAppliedMessage && (
        <span aria-hidden="true" className={styles.tax_message}>
          (tax. included)
        </span>
      )}
    </p>
  );
};

export default Price;
